import { Loader2 } from "lucide-react";


interface LoadingComponentProps {
    isLoading?: boolean;
    message?: string;
}
const LoadingComponent = ({ isLoading, message }: LoadingComponentProps) => {
    return (
        <div className="p-6 bg-white rounded-lg flex flex-row gap-4 items-center">
            <Loader2 className="animate-spin rounded-full h-4 w-4" />
            <div>{message || 'Generating report data...'}</div>
        </div>
    )
}

export default LoadingComponent;